import { render, staticRenderFns } from "./ReportingWorkspace.vue?vue&type=template&id=b5a78e24&scoped=true&"
import script from "./ReportingWorkspace.vue?vue&type=script&lang=js&"
export * from "./ReportingWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./ReportingWorkspace.vue?vue&type=style&index=0&id=b5a78e24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a78e24",
  null
  
)

export default component.exports